// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__minervaModern_879bc4', '__minervaModern_Fallback_879bc4'"},"className":"__className_879bc4","variable":"__variable_879bc4"};